import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import HelpOutlineOutlinedIcon from '@material-ui/icons/HelpOutlineOutlined';
import Title from '../Title/index';
import { useTranslation } from '../../src/i18n';
import { fontSize } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  questionIcon: {
    fontSize: fontSize.smallTitle,
    marginLeft: 5,
    cursor: 'pointer',
  },
}));

const TitleWithInfo = ({ title, titleSize, titleColor, tooltip, iconSize, ...rest }) => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div>
      <Title size={titleSize} color={titleColor} {...rest}>
        {t(title)}
      </Title>
      <Tooltip title={t(tooltip)} placement="right">
        <HelpOutlineOutlinedIcon fontSize={iconSize} className={classes.questionIcon} />
      </Tooltip>
      <br />
    </div>
  );
};

TitleWithInfo.propTypes = {
  title: PropTypes.string.isRequired,
  titleSize: Title.propTypes.size,
  tooltip: PropTypes.string.isRequired,
  iconSize: PropTypes.oneOf(['default', 'small', 'large']),
};

TitleWithInfo.defaultProps = {
  titleSize: 'regular',
  iconSize: 'small',
};

export default TitleWithInfo;
